import styled from 'styled-components';

export const Container = styled.div`
  .dados-modal {
    max-height: 70vh; /* Defina a altura máxima desejada (70% da altura da viewport neste exemplo) */
    overflow-y: auto; /* Adiciona uma barra de rolagem vertical quando necessário */
  }

  .dados-de-contato {
    background: #eee;
    padding: 10px 10px;
  }
`;
